import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'ui/ReactTable';
import { Button } from '@material-ui/core';
import { RedButton } from './Grid.styles';


const Grid = ({ data, onEdit, removeItem }) => (
  <div>
    <ReactTable
      data={data}
      columns={[
        {
          Header: 'ID',
          accessor: 'idCollaboratingCenter',
          maxWidth: 30,
        },
        {
          Header: 'Nombre Centro Colaborador',
          accessor: 'name',
        },
        {
          Header: 'Codigo',
          accessor: 'code',
        },
        {
          Header: 'Acciones',
          fixed: 'right',
          columns: [
            {
              Cell: row => (
                <Button onClick={() => onEdit(row.original.idCollaboratingCenter)}>Editar</Button>
              ),
              resizable: false,
              sortable: false,
              maxWidth: 70,
            },
            {
              Cell: row => (
                <RedButton onClick={() => removeItem(row.original.idCollaboratingCenter)}>
                    Borrar
                </RedButton>
              ),
              resizable: false,
              sortable: false,
              maxWidth: 100,
            },
          ],
        },
      ]}
    />
  </div>
);

Grid.propTypes = {
  data: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
};

export default Grid;
